

// src/pages/TikpagDiagnostico.jsx

import React, { useEffect, useState } from "react";
import axios from "../axiosConfig";
import {
  AlertTriangle,
  CheckCircle2,
  Database,
  RefreshCcw,
  ServerCrash
} from "lucide-react";

import "./TikpagDiagnostico.css";

function TikpagDiagnostico() {
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");

  const carregarDiagnostico = async () => {
    setLoading(true);
    setErro("");

    try {
      const { data } = await axios.get(
        "/admin/tikpag-api-diagnostico"
      );

      setDados(data);
    } catch (err) {
      console.error(err);

      setErro(
        err.response?.data?.error ||
          "Não foi possível executar o diagnóstico da API Tikpag."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarDiagnostico();
  }, []);

  return (
    <div className="tikpagDiagnostico-page">
      <div className="tikpagDiagnostico-header">
        <div>
          <span className="tikpagDiagnostico-kicker">
            Integração Tikpag
          </span>

          <h1>Diagnóstico da API</h1>

          <p>
            Esta página testa automaticamente os possíveis
            endpoints da API Tikpag para identificar quais
            consultas podem ser utilizadas em futuros painéis
            de BI, ranking e acompanhamento de empresas.
          </p>
        </div>

        <button
          type="button"
          onClick={carregarDiagnostico}
          disabled={loading}
          className="tikpagDiagnostico-refresh"
        >
          <RefreshCcw
            size={16}
            className={loading ? "tikpagDiagnostico-spin" : ""}
          />
          Atualizar
        </button>
      </div>

      {erro && (
        <div className="tikpagDiagnostico-alert error">
          <ServerCrash size={18} />
          <span>{erro}</span>
        </div>
      )}

      {!erro && !dados && (
        <div className="tikpagDiagnostico-loading">
          Carregando...
        </div>
      )}

      {dados && (
        <>
          <div className="tikpagDiagnostico-alert info">
            <Database size={18} />

            <span>
              Período testado:
              {" "}
              <strong>
                {dados.periodo_testado?.inicio}
              </strong>
              {" "}
              até
              {" "}
              <strong>
                {dados.periodo_testado?.fim}
              </strong>
            </span>
          </div>

          <div className="tikpagDiagnostico-grid">
            {dados.resultados?.map((item, index) => (
              <div
                key={index}
                className={`tikpagDiagnostico-card ${
                  item.sucesso
                    ? "success"
                    : "error"
                }`}
              >
                <div className="tikpagDiagnostico-cardHeader">
                  {item.sucesso ? (
                    <CheckCircle2 size={18} />
                  ) : (
                    <AlertTriangle size={18} />
                  )}

                  <strong>{item.nome}</strong>
                </div>

                <div className="tikpagDiagnostico-cardBody">
                  <div>
                    <span>Endpoint</span>
                    <code>{item.endpoint}</code>
                  </div>

                  {item.sucesso ? (
                    <>
                      <div>
                        <span>Status</span>
                        <strong>{item.status}</strong>
                      </div>

                      <div>
                        <span>Tempo</span>
                        <strong>
                          {item.duracao_ms} ms
                        </strong>
                      </div>

                      <div>
                        <span>Tipo</span>
                        <strong>
                          {item.tipo_payload}
                        </strong>
                      </div>

                      <div>
                        <span>Total estimado</span>
                        <strong>
                          {item.total_estimado ?? "-"}
                        </strong>
                      </div>

                      <div>
                        <span>Chaves retornadas</span>

                        <pre>
                          {JSON.stringify(
                            item.chaves_payload,
                            null,
                            2
                          )}
                        </pre>
                      </div>

                      <div>
                        <span>Amostra</span>

                        <pre>
                          {JSON.stringify(
                            item.amostra,
                            null,
                            2
                          )}
                        </pre>
                      </div>
                    </>
                  ) : (
                    <div>
                      <span>Erro</span>

                      <pre>
                        {JSON.stringify(
                          item.erro,
                          null,
                          2
                        )}
                      </pre>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default TikpagDiagnostico;